import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const ContactsIcon = createSvgIcon(
  <path
    d="M15.3 18.6C15.3 17.433 14.8364 16.3139 14.0113 15.4887C13.1861 14.6636 12.067 14.2 10.9 14.2M10.9 14.2C9.73305 14.2 8.61389 14.6636 7.78873 15.4887C6.96357 16.3139 6.5 17.433 6.5 18.6M10.9 14.2C12.7225 14.2 14.2 12.7225 14.2 10.9C14.2 9.07746 12.7225 7.6 10.9 7.6C9.07746 7.6 7.6 9.07746 7.6 10.9C7.6 12.7225 9.07746 14.2 10.9 14.2ZM6.5 1V3.2M15.3 1V3.2M3.2 3.2H18.6C19.815 3.2 20.8 4.18497 20.8 5.4V20.8C20.8 22.015 19.815 23 18.6 23H3.2C1.98497 23 1 22.015 1 20.8V5.4C1 4.18497 1.98497 3.2 3.2 3.2Z"
    {...strokeProps}
  />,
  { displayName: 'ContactsIcon', viewBox: '0 0 22 24' }
);
